/**
 * Web Style Import
 *
 */

import './dnb-progress-indicator.scss'
